/**
 * Navigation Panel — left-side collapsible panel for switching views.
 * Mirrors the right sidebar's toggle behaviour; persists state in localStorage.
 */

import { emit } from '../core/event-bus.js';

const NAV_STORAGE_KEY = 'map-projection-nav-state';

function loadNavState() {
    return localStorage.getItem(NAV_STORAGE_KEY) === 'expanded';
}

function saveNavState(isExpanded) {
    localStorage.setItem(NAV_STORAGE_KEY, isExpanded ? 'expanded' : 'collapsed');
}

function toggleNav(forceState) {
    const container = document.getElementById('nav-container');
    const isCurrentlyExpanded = container.classList.contains('nav-expanded');
    const shouldExpand = forceState !== undefined ? forceState : !isCurrentlyExpanded;

    if (shouldExpand) {
        container.classList.remove('nav-collapsed');
        container.classList.add('nav-expanded');
    } else {
        container.classList.remove('nav-expanded');
        container.classList.add('nav-collapsed');
    }

    saveNavState(shouldExpand);
    return shouldExpand;
}

/**
 * Initialize the navigation panel
 * @param {Object} app - Application state from main.js
 */
export function initNav(app) {
    // Restore saved state
    toggleNav(loadNavState());

    // Toggle button
    document.getElementById('nav-toggle').addEventListener('click', () => toggleNav());

    // View buttons
    document.querySelectorAll('.view-button').forEach((btn) => {
        btn.addEventListener('click', () => {
            const view = btn.dataset.view;
            if (!app.viewManager) return;
            app.viewManager.switchTo(view);
            document.querySelectorAll('.view-button').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            emit('render:dirty');
        });
    });

    // Expose for console testing
    window.toggleNav = toggleNav;
}
